import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthRegimen } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";



export const HealthAttentionGateEntry = () => {

    const attentry = useDataBean(_HealthAttentionGateEntry);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

   useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        attentry.instance.getHealthAttentionGateEntryCatalog(null,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        attentry.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        attentry.deleteItemVoid(attentry.bean.IDHealthAttentionGateEntry).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(entailment.bean);
        attentry.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthAttentionGateEntry', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${attentry.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Puertas de Entrada de Atención">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={attentry.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={attentry.bean.Code} onChange={(e: any) => { attentry.setBean({ ...attentry.bean, 'Code': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={attentry.bean.Name} onChange={attentry.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={attentry.bean.Description} onChange={attentry.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {attentry.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}